import { render, staticRenderFns } from "./group-page.vue?vue&type=template&id=67fbd9c7"
import script from "./group-page.vue?vue&type=script&lang=js"
export * from "./group-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67fbd9c7')) {
      api.createRecord('67fbd9c7', component.options)
    } else {
      api.reload('67fbd9c7', component.options)
    }
    module.hot.accept("./group-page.vue?vue&type=template&id=67fbd9c7", function () {
      api.rerender('67fbd9c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/Groups/group-page.vue"
export default component.exports